export const PersonIcon = ({ color = '#03DBE3', ...props }) => (
  <svg
    width={'18'}
    height={'18'}
    viewBox={'0 0 18 18'}
    fill={'none'}
    xmlns={'http://www.w3.org/2000/svg'}
    {...props}
  >
    <path
      fillRule={'evenodd'}
      clipRule={'evenodd'}
      d={'M12.3008 9.74313C13.4788 8.8134 14.2349 7.37282 14.2349 5.75563C14.2349 2.95173 11.9619 0.678711 9.15802 0.678711C6.35411 0.678711 4.0811 2.95173 4.0811 5.75563C4.0811 7.37282 4.83722 8.8134 6.01522 9.74313C3.14772 10.8909 1.05482 13.5627 0.738143 16.7568C0.692037 17.2219 1.07532 17.6018 1.54264 17.6018H16.7734C17.2407 17.6018 17.624 17.2219 17.5779 16.7568C17.2612 13.5627 15.1683 10.8909 12.3008 9.74313Z'}
      fill={color}
    />
  </svg>
);
